<div class="social-wall-detail">
  <button
    mat-icon-button
    class="button button--icon button--transparent social-wall-detail__close"
    data-cy="social-wall-detail-close"
    (click)="close()">
    <lib-icon icon="x" [size]="24"></lib-icon>
  </button>

  <button
    mat-icon-button
    class="button button--icon social-wall-detail__nav social-wall-detail__nav--previous"
    [disabled]="!canGoPrevious()"
    [class.hidden]="!canGoPrevious()"
    data-cy="social-wall-detail-previous"
    (click)="goTo(-1)">
    <lib-icon icon="caret-left"></lib-icon>
  </button>

  <div
    #contentScroll
    class="social-wall-detail__content"
    [class.social-wall-detail__content--text-only]="!media()">
    @if (media(); as media) {
      <div class="social-wall-detail__media" [ngClass]="media.type">
        @switch (media.type) {
          @case ('image') {
            <img
              class="social-wall-detail__media-image"
              [cropImage]="media.value | preSignedUrl | async"
              [imageWidth]="1440"
              [dynamicWidth]="false"
              alt="">
          }
          @case ('video') {
            <lib-video class="social-wall-detail__media-video" [src]="(media.value | videoPresign | async) ?? ''"></lib-video>
          }
          @case ('audio') {
            <lib-audio-player-v2
              class="social-wall-detail__media-audio"
              [src]="(media.value | preSignedUrl : entityTypeId.MEDIA : bundleType.AUDIO : fieldName.AWS_FILE | async) ?? ''">
            </lib-audio-player-v2>
          }
        }
      </div>
    }

    <div class="social-wall-detail__panel">
      <div class="social-wall-detail__post">
        <div class="social-wall-detail__user">
          <lib-user-avatar [size]="48" [user]="item()?.author"></lib-user-avatar>
          <div class="social-wall-detail__user-details">
            <div class="social-wall-detail__user-name">{{ item()?.author?.formattedProfileName }}</div>
            <div class="social-wall-detail__user-time">{{ item()?.created | timeElapsed }}</div>
          </div>
        </div>

        <div class="social-wall-detail__text" [innerHtml]="item()?.text"></div>

        @if (item()?.linkToContent; as content) {
          @if (content.access_denied) {
            <div class="social-wall-detail__reference social-wall-detail__reference--denied">
              <lib-icon icon="lock-simple" [size]="18"></lib-icon>
              <span>{{ 'SOCIAL_WALL.content_not_available' | translate }}</span>
            </div>
          } @else {
            <div
              class="social-wall-detail__reference"
              data-cy="social-wall-detail-open-reference"
              (click)="openLinkToContent(content)">
              <div
                class="social-wall-detail__reference-image"
                [placeholderImage]="!content.mediaImage && content.bundle"
                [cropImage]="(content.mediaImage | preSignedUrl | async) || content.image">
              </div>
              <div class="social-wall-detail__reference-body">
                <span class="social-wall-detail__reference-type">{{ content | bundleLabel | async }}</span>
                <span class="social-wall-detail__reference-title">{{ content.title }}</span>
              </div>
            </div>
          }
        }

        <div class="social-wall-detail__actions">
          <div class="social-wall-detail__action-list">
            <button
              type="button"
              class="social-wall-detail__action"
              data-cy="social-wall-detail-like"
              (click)="toggleLike()">
              <lib-icon icon="heart" [fill]="!!item()?.userLiked"></lib-icon>
              {{ item()?.totalLikes || 0 }}
            </button>
            <div class="social-wall-detail__action">
              <lib-icon icon="chat-teardrop-text"></lib-icon>
              {{ repliesCount() }}
            </div>
          </div>

          <button
            mat-button
            class="button button--icon"
            data-cy="social-wall-detail-pin"
            (click)="togglePin()">
            <lib-icon icon="push-pin" [fill]="!!item()?.pinned"></lib-icon>
          </button>
        </div>
      </div>

      <div #repliesScroll class="social-wall-detail__replies" (scroll)="onRepliesScroll($event)">
        <div class="social-wall-detail__replies-title">
          {{ 'SOCIAL_WALL.replies_count' | translate:{ count: repliesCount() } }}
        </div>

        @for (reply of replies(); track reply.id || $index) {
          <lib-social-wall-reply
            [reply]="reply"
            (like)="toggleLike($event)"
            (replyTo)="replyTo($event)"
            (loadReplies)="loadReplies($event)">
          </lib-social-wall-reply>
        }

        @if (isLoadingMoreReplies()) {
          <div class="social-wall-detail__replies-loading">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        }
      </div>

      <form class="social-wall-detail__composer" (submit)="$event.preventDefault(); submitReply()">
        @if (replyTarget(); as target) {
          <div class="social-wall-detail__composer-target">
            <span>{{ 'SOCIAL_WALL.replying_to' | translate:{ name: target.author?.formattedProfileName } }}</span>
            <button
              type="button"
              mat-icon-button
              class="button button--icon button--icon-extra-small"
              data-cy="social-wall-detail-cancel-reply"
              (click)="clearReply()">
              <lib-icon icon="x" [size]="16"></lib-icon>
            </button>
          </div>
        }

        <div class="social-wall-detail__composer-field">
          @if (profile$ | async; as user) {
            <lib-user-avatar [size]="32" [user]="user"></lib-user-avatar>
          }

          <div class="social-wall-detail__composer-box">
            <input
              #replyField
              type="text"
              class="social-wall-detail__composer-input"
              [placeholder]="'SOCIAL_WALL.post_your_reply' | translate"
              [value]="replyText()"
              [disabled]="isSubmittingReply()"
              data-cy="social-wall-detail-reply-field"
              (input)="replyText.set($any($event.target).value)">

            <button
              type="submit"
              mat-icon-button
              class="button button--icon button--primary button--icon-extra-small"
              [disabled]="!replyText() || isSubmittingReply()"
              data-cy="social-wall-detail-reply-submit">
              @if (isSubmittingReply()) {
                <mat-spinner color="primary-text" [diameter]="20"></mat-spinner>
              } @else {
                <lib-icon icon="arrow-up"></lib-icon>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <button
    mat-icon-button
    class="button button--icon social-wall-detail__nav social-wall-detail__nav--next"
    [disabled]="!canGoNext()"
    [class.hidden]="!canGoNext()"
    data-cy="social-wall-detail-next"
    (click)="goTo(1)">
    <lib-icon icon="caret-right"></lib-icon>
  </button>
</div>
